import React from "react";

const SITE = "https://indiansoud.com";
const DEFAULT_IMG = "https://images.unsplash.com/photo-1736098687867-3ec9f69aff2e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

// React 19 hoists <title>, <meta> and <link> to <head> automatically.
const Seo = ({ title, description, path = "", keywords, image, jsonLd }) => {
  const url = `${SITE}${path}`;
  const img = image || DEFAULT_IMG;
  const fullTitle = title.includes("Meilleur") ? title : `${title} | Meilleur Oudh & Aromas`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Meilleur Oudh & Aromas" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      )}
    </>
  );
};

export default Seo;
export { SITE };
